import { QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { Cliente, ClientesQuery } from "@/shared/types/cliente";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function getAllClientes(query?: ClientesQuery): Promise<QueryResponse<Cliente>> {
    await sleep(1000);
    const response = await api.get("clientes", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllClientesQuery(query: ClientesQuery = {}, queryConfig: QueryConfig<QueryResponse<Cliente>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllClientes(query),
        queryKey: ["clientes", query],
    })
}

export interface GetAllClienteQueryProps {
    query?: ClientesQuery,
    queryConfig?: QueryConfig<QueryResponse<Cliente>>,
    children: (queryResult: QueryResult<QueryResponse<Cliente>>) => ReactNode
}

export function GetAllClientesQuery({
    query,
    queryConfig,
    children
}: GetAllClienteQueryProps) {
    const queryResult = useGetAllClientesQuery(query, queryConfig);
    return children && children(queryResult);
}